import React from 'react'
import { AppContainer } from '~/views/shared'
import { TransfersIndexPage } from './TransfersIndexPage'
import { Route, Switch } from 'react-router-dom'
import { ROUTES } from '~/views/routes'

export const TransfersPage = () => {
  return (
    <AppContainer title='Transferencias'>
      <Switch>
        <Route
          exact
          path={ROUTES.ADMIN.TRANSFERS.INDEX}
          component={TransfersIndexPage}
        />
      </Switch>
    </AppContainer>
  )
}

export default TransfersPage
